<script lang="ts" setup>
import { computed, onMounted } from "vue";
import { useStoryboardsStore } from "@/modules/storyboards/store";
import { useSnackbar } from "@/shared/hooks/useSnackbar";
import router from "@/router";
import { storyboardsRoutesNames } from "../routes";

const task = defineModel<any>("taskItem");
const dialogVisibleMV = defineModel("dialogVisible");
const props = defineProps<{
  dialogVisible?: boolean;
  position: number;
  taskItem: any;
  storyboardData: any;
  localization: any;
}>();

defineEmits(["update:dialogVisible", "update:taskItem"]);

const storyboardsStore = useStoryboardsStore();

const itemName = computed(() => {
  return `${props.taskItem.storyboardData.name} [${props.localization.language.code} - ${props.localization.country.code}]`;
});

const { pushNotification } = useSnackbar();

storyboardsStore.$onAction(({ name, args }) => {
  const [id, isSuccess] = args;

  if (name === "setStoryboardAITaskSuccess" && id === task.value?.id) {
    if (isSuccess) {
      const link = router.resolve({
        name: storyboardsRoutesNames.localizations(),
        params: {
          storyboardId: task.value.storyboardData.id,
          storyboardLocalizationId: task.value.localization.id,
        },
      }).href;

      pushNotification(
        "success",
        `<strong>${itemName.value} successfully translated.</strong> <br>
        <a href="${link}">See Content Matrix Localization</a>.`,
      );
    } else {
      pushNotification(
        "error",
        `An error occurred while translating content for “${itemName.value}” using AI.`,
        {
          timeout: -1,
        },
      );
    }

    storyboardsStore.removeStoryboardAITask(task.value.id);
  }
});

onMounted(() => {
  task.value!.isInProgress = true;
});
</script>
<template>
  <EccaSnackbar
    v-model="dialogVisibleMV"
    :color="'info'"
    :prependIcon="'$StoreBuildingWarehouse'"
    class="processing-ai-snackbar pt-10"
    :style="`transform: translateY(${position * 120}px)`"
  >
    <div class="ecca-snackbar__text font-weight-bold">
      {{ itemName }} is being translated.
    </div>
    <div>It can take between 5 and 30 minutes.</div>
    <VProgressLinear
      class="processing-ai-snackbar__progress"
      indeterminate
      color="secondary"
    />
  </EccaSnackbar>
</template>

<style scoped>
.processing-ai-snackbar__progress {
  width: 100%;
  margin: 10px 0;
}
</style>
